<div>
  <h1 class="eca-skip-link-focus-target" tabindex="-1">Security UI</h1>
  <h3>Please Log In</h3>
  <p>We are sorry, but a problem has occurred. Please click the 'Log in' button to proceed.</p>
</div>
